import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    EBON_ACTIVATION_TYPE_ONLINE,
    EBON_ACTIVATION_TYPE_OFFLINE,
    EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE
} from '../../constants/ebon';
import { STATIC_ROOT } from '../../constants';
import {
    MERCHANTPAGE_COUPON_ANCHOR,
    EBON_CUMUL_ON_PARTNER_BLOCKS
} from '../../services/partner/constants';

import {
    getMerchantCardUrl,
    displayableCashback,
    hasCashback,
    hasEbon
} from '../../services/partner/utils';
import { getBilletterieMerchantUrl } from '../../services/billetterie/utils';
import { isBilletteriePartner } from '../../services/billetterie/selector';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import SvgComponent from '../SvgComponent';
import LogoPartenaireComponent from './LogoPartenaireComponent';
import LinkButtonComponent from '../button/LinkButtonComponent';
import CashbackBlocPartenaireComponent from './CashbackBlocPartenaireComponent';
import CodePromoBlocPartenaireComponent from './CodePromoBlocPartenaireComponent';

import './PartnerBlockComponent.scss';

class PartnerBlockComponent extends React.Component {
    getEbonAvailability = ebonDiscount => {
        const { i18n } = this.props;

        if (ebonDiscount.activationType === EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE) {
            return i18n.EBON_TYPE_ON_OFF;
        } else if (ebonDiscount.activationType === EBON_ACTIVATION_TYPE_ONLINE) {
            return i18n.EBON_TYPE_ON;
        } else if (ebonDiscount.activationType === EBON_ACTIVATION_TYPE_OFFLINE) {
            return i18n.EBON_TYPE_OFF;
        }
        return null;
    };

    getEbonPartnerCashbackCumulable = partner => {
        const { i18n, partners } = this.props;

        if (partner.ebonDiscount.cumulativeWithCashbackDiscount) {
            const onlinePartner = partners[partner.id] ? partners[partner.id] : null;
            if (hasCashback(onlinePartner)) {
                const discount = onlinePartner.mostDisplayableDiscountOnline;
                let onlineCashback = onlinePartner.isMultiDiscount ? `${i18n.jusqua} ` : '';
                onlineCashback += `${displayableCashback(discount.percent, discount.fixed)} `;
                return (
                    <div className="ebonCumul">
                        {convertHtmlToReactDomWithParams(
                            i18n.EBON_CASHBACK_CUMULABLE,
                            onlineCashback
                        )}
                    </div>
                );
            }
        }
        return <div className="ebonCumul noCb">{i18n.EBON_CASHBACK_NOT_CUMULABLE}</div>;
    };

    render() {
        const {
            i18n,
            partner,
            urlCustom,
            isCodePromo,
            isOffline,
            hideType,
            isEbon,
            isBilletterie,
            isBilletterieMerchant,
            isCouponsOnly,
            tabIndex
        } = this.props;

        // Bloc billetterie (annuaire), ou offre bon d'achat d'un marchand billetterie : zone billetterie
        const toBilletterie = !urlCustom && (isBilletterie || (isEbon && isBilletterieMerchant));
        const buttonText = isBilletterie
            ? i18n.BOOK
            : isEbon
            ? i18n.jachete
            : isOffline
            ? i18n.discover
            : i18n.jenprofite;
        // Bloc code promo : le lien cible directement la section des codes de
        // réduction de la fiche marchand (pas en codes promo seuls : le 1er code est en en-tête).
        const urlFicheMarchand = !partner
            ? null
            : toBilletterie
            ? getBilletterieMerchantUrl(partner)
            : `${getMerchantCardUrl(partner, isOffline, isEbon)}${
                  isCodePromo && !isCouponsOnly ? `#${MERCHANTPAGE_COUPON_ANCHOR}` : ''
              }`;
        const ebonCbCumulable =
            EBON_CUMUL_ON_PARTNER_BLOCKS && isEbon && hasEbon(partner)
                ? this.getEbonPartnerCashbackCumulable(partner)
                : null;

        return (
            partner && (
                <article className="bloc-partenaire txtcenter flex-container-v flex-center-alt">
                    {!hideType && (
                        <p className="type">
                            {isBilletterie ? (
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-billetterie.svg`}
                                        className="picto"
                                        width="21"
                                        height="15"
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                    <span>
                                        {convertHtmlToReactDomWithParams(
                                            i18n.OFFER,
                                            i18n.TICKETING_TYPE
                                        )}
                                    </span>
                                </React.Fragment>
                            ) : isCouponsOnly ? (
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/code-promo.svg`}
                                        className="picto"
                                        width="17"
                                        height="20"
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                    <span>
                                        {convertHtmlToReactDomWithParams(
                                            i18n.OFFER,
                                            i18n.COUPON_TYPE
                                        )}
                                    </span>
                                </React.Fragment>
                            ) : isOffline ? (
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-magasin.svg`}
                                        className="picto"
                                        width="20"
                                        height="20"
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                    <span className="off">
                                        {convertHtmlToReactDomWithParams(i18n.OFFER, i18n.OFFLINE)}
                                    </span>
                                </React.Fragment>
                            ) : isEbon ? (
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-ebon.svg`}
                                        className="picto"
                                        width="20"
                                        height="18"
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                    <span>
                                        {convertHtmlToReactDomWithParams(i18n.OFFER, i18n.EBON)}
                                    </span>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-en-ligne.svg`}
                                        className="picto"
                                        width="20"
                                        height="20"
                                        aria-hidden="true"
                                        focusable="false"
                                    />
                                    <span>
                                        {convertHtmlToReactDomWithParams(i18n.OFFER, i18n.ONLINE)}
                                    </span>
                                </React.Fragment>
                            )}
                        </p>
                    )}
                    <LogoPartenaireComponent
                        partenaire={partner}
                        url=""
                        title={partner.name ? `Fiche ${partner.name}` : ''}
                        cssClass={`logo all-link${isBilletterie ? ' logo-billetterie' : ''}`}
                        src={isBilletterie ? partner.logoUrl : undefined}
                        titleTag
                    />
                    <hr />
                    {isCodePromo || isCouponsOnly ? (
                        <CodePromoBlocPartenaireComponent
                            partner={partner}
                            cssClassContainer="blp-reduction"
                            // Grille mixte : codes promo et bons plans confondus
                            asOffers={isCouponsOnly && !isCodePromo}
                        />
                    ) : (
                        <CashbackBlocPartenaireComponent
                            partner={partner}
                            cssClassContainer="blp-reduction"
                            isOffline={isOffline}
                            isEbon={isEbon}
                            isBilletterie={isBilletterie}
                            ebonCbCumulable={ebonCbCumulable}
                        />
                    )}
                    <div className="bt-conteneur w100">
                        <LinkButtonComponent
                            to={urlCustom ? urlCustom : urlFicheMarchand}
                            title={partner.name ? `${buttonText} : ${partner.name}` : ''}
                            text={buttonText}
                            color="main"
                            tabIndex={tabIndex}
                            external={toBilletterie}
                        />
                    </div>
                    <div className={`ebonValidity ${!hasEbon(partner) ? 'no-ebon' : ''}`}>
                        {isEbon &&
                            hasEbon(partner) &&
                            this.getEbonAvailability(partner.ebonDiscount)}{' '}
                    </div>
                </article>
            )
        );
    }
}

PartnerBlockComponent.propTypes = {
    urlCustom: PropTypes.string,
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    isBilletterie: PropTypes.bool,
    // Marchand à codes promo seuls (fiche "Offres")
    isCouponsOnly: PropTypes.bool,
    partner: PropTypes.object,
    hideType: PropTypes.bool
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state, ownProps) {
    return {
        i18n: state.i18n.feature.partenaire,
        partners: state.partner.partners,
        isBilletterieMerchant: isBilletteriePartner(state, ownProps.partner && ownProps.partner.id)
    };
}

export default connect(mapStateToProps)(PartnerBlockComponent);



// WEBPACK FOOTER //
// ./src/components/partner/PartnerBlockComponent.js